/**
 * AngularJS Upgraded Components
 *
 * This file contains wrapper directives that allow AngularJS components
 * to be used in Angular templates.
 *
 * Usage in Angular template:
 * ```html
 * <legacy-loader [loaderId]="'main'" [hidden]="false"></legacy-loader>
 * ```
 *
 * Add these directives to SharedModule declarations.
 */
// Uncomment these when adding an UpgradeComponent wrapper below.
// import { Directive, ElementRef, Inject, Injector, Input } from '@angular/core';
// import { UpgradeComponent } from '@angular/upgrade/static';

// ============================================
// Upgraded AngularJS Directives
// ============================================
// Uncomment as needed during migration

/**
 * Wrapper for AngularJS 'loader' directive
 *
 * Usage:
 * ```html
 * <legacy-loader loaderId="main" hidden="false"></legacy-loader>
 * ```
 */
// @Directive({ selector: 'legacy-loader' })
// export class LegacyLoaderDirective extends UpgradeComponent {
//   @Input() loaderId: string;
//   @Input() hidden: string;
//
//   constructor(elementRef: ElementRef, injector: Injector) {
//     super('loader', elementRef, injector);
//   }
// }

/**
 * NOTE: The former `legacy-spinner` wrapper was removed. The AngularJS `spinner`
 * directive (which used `replace: true`, incompatible with UpgradeComponent) has
 * been migrated to the native Angular `SpinnerComponent`
 * (apps/b2b-frontend/app/shared/components/spinner). AngularJS templates use the
 * downgraded `<ng-spinner>`; Angular templates use `<app-spinner>` directly.
 */

/**
 * NOTE: The former `legacy-acme-alert` wrapper was removed. `acme-alert` is now
 * the native Angular `AlertComponent` (apps/b2b-frontend/app/shared/components/alert),
 * so Angular templates should use `<app-alert>` directly instead of wrapping it.
 */

/**
 * Wrapper for AngularJS 'dataGrid' directive
 *
 * Usage:
 * ```html
 * <legacy-data-grid [options]="gridOptions"></legacy-data-grid>
 * ```
 */
// @Directive({ selector: 'legacy-data-grid' })
// export class LegacyDataGridDirective extends UpgradeComponent {
//   @Input() options: any;
//
//   constructor(elementRef: ElementRef, injector: Injector) {
//     super('dataGrid', elementRef, injector);
//   }
// }

/**
 * All upgraded AngularJS component directives
 * Add to SharedModule declarations
 */
export const AJS_UPGRADED_COMPONENTS = [
  // LegacyLoaderDirective,
  // LegacyDataGridDirective,
];

/**
 * Example: How to upgrade an AngularJS directive for use in Angular
 *
 * 1. Create wrapper directive:
 * ```typescript
 * @Directive({ selector: 'legacy-my-directive' })
 * export class LegacyMyDirective extends UpgradeComponent {
 *   @Input() myInput: string;
 *   @Output() myOutput = new EventEmitter<any>();
 *
 *   constructor(elementRef: ElementRef, injector: Injector) {
 *     // 'myDirective' is the AngularJS directive name (camelCase)
 *     super('myDirective', elementRef, injector);
 *   }
 * }
 * ```
 *
 * 2. Add to SharedModule declarations
 *
 * 3. Use in Angular template:
 * ```html
 * <legacy-my-directive
 *   [myInput]="value"
 *   (myOutput)="handleOutput($event)">
 * </legacy-my-directive>
 * ```
 */

